import { render } from "./BDBarChart.vue?vue&type=template&id=263a3594&scoped=true"
import script from "./BDBarChart.vue?vue&type=script&lang=js"
export * from "./BDBarChart.vue?vue&type=script&lang=js"

import "./BDBarChart.vue?vue&type=style&index=0&id=263a3594&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263a3594"]])

export default __exports__